<template src="../../../../components/shared/physicianSearch/BaseSearchResultsTemplate.html">
</template>

<script>
    import {basePresenterMixin} from "../../../../components/shared/mixins/basePresenterMixin.js";
    import SearchResult from "./SearchResult.vue";
    import MapView from "../../../../components/shared/physicianSearch/MapView.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "SearchResultsPresenter",
        components: {SearchResult, MapView},
        mixins: [basePresenterMixin],
        props: {
            companyId: {type: [Number], required: true},
            token: {type: [String], required: true},
        },
        data() {
            return {
                additionalData: {companyId: this.companyId, token: this.token},
            };
        },
        computed: {
            ...mapGetters({showVirtualPlans: 'globalSettings/showVirtualPlans'})
        },
        mounted() {
            this.baseInit();
        }
    }
</script>

<style scoped>
    .pagination-box {
        display: flex;
        justify-content: center;
        margin: 10px;
        align-items: center;
    }

    .pagination-box button {
        margin: 0 5px;
    }
</style>